'use client'

import * as stylex from '@stylexjs/stylex'
import { RefObject, createContext, useContext, useRef } from 'react'
import { ButtonProps } from '../Buttons'
import { LinkButton } from '../Buttons/LinkButton'

type Context = {
  serviceLinkButtonRef?: RefObject<HTMLAnchorElement | null>
}

export const ServiceLinkContext = createContext<Context>({})

interface ServiceLinkProviderProps {
  children: React.ReactNode
  styles?: stylex.StyleXStyles
}

export function ServiceLinkProvider({
  children,
  styles,
}: ServiceLinkProviderProps) {
  const serviceLinkButtonRef = useRef<HTMLAnchorElement>(null)

  function clickHandler() {
    serviceLinkButtonRef.current?.click()
  }

  return (
    <ServiceLinkContext.Provider value={{ serviceLinkButtonRef }}>
      <li onClick={clickHandler} {...stylex.props(styles)}>
        {children}
      </li>
    </ServiceLinkContext.Provider>
  )
}

interface ControlledLinkButtonProps extends ButtonProps {
  href?: string
}

export function ControlledLinkButton(props: ControlledLinkButtonProps) {
  const { serviceLinkButtonRef } = useContext(ServiceLinkContext)
  return (
    <LinkButton ref={serviceLinkButtonRef} controlled {...props}>
      {props.children}
    </LinkButton>
  )
}
